// Google sign-up redirects away to accounts.google.com and back to /sso-callback, so we can't
// call the consent endpoint inline like the password flow does — stash the fact that the user
// checked the agreement box before leaving, and SSOCallback picks it up once the session is live.
export const PENDING_CONSENT_KEY = 'rt_pending_signup_consent';
